import { render } from "./chartComponentRecent.vue?vue&type=template&id=31b4a2cf&scoped=true"
import script from "./chartComponentRecent.vue?vue&type=script&lang=js"
export * from "./chartComponentRecent.vue?vue&type=script&lang=js"

import "./chartComponentRecent.vue?vue&type=style&index=0&id=31b4a2cf&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b4a2cf"]])

export default __exports__